export const useStatamicPost = () => {
    const statamic = useStatamic()

    const submit = (endpoint, data) =>
        statamic(endpoint, {
            method: 'POST',
            body: data,
        })

    return {
        submit,
    }
}
